var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"reportWork",staticClass:"ui-report-work",class:_vm.isTop ? 'top' : ''},[_c('WorkList',{attrs:{"worksList":_vm.worksList},on:{"resfresPraise":_vm.handleRefreshPrasie}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }